module.exports = __webpack_public_path__ + "media/images/perm_identity-24px-5077b704780183655ccaa4a44ab8a05c.svg";